import React from 'react';
import { useParams } from 'react-router-dom';
import MsgNetLoading from '../components/MsgNetLoading';
import ResultadosScrapeable from '../components/ResultadosScrapeable';
import CONFIG from '../config';
import { applyDelta } from '../utils/wsDelta';

class ScrapeableScreenClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            competicion: null,
            sectores: [],
            controles: [],
            resultados: []
        };
        this.ws = null;
        this.wsReconnectTimer = null;
    }

    componentDidMount() {
        const competicionId = parseInt(this.props.params.competicionId, 10);
        this.fetchInitData(competicionId);
        this.connectWS(competicionId);
    }

    fetchInitData(competicionId) {
        fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
            .then(r => r.json())
            .then(data => {
                this.setState({
                    competicion: data.competicion,
                    sectores: data.sectores,
                    controles: data.controles,
                });
            })
            .catch(err => console.error('live-init error:', err));
    }

    connectWS(competicionId) {
        if (this.ws) this.ws.close();
        this.ws = new WebSocket(`${CONFIG.WS_URL}/ws/${competicionId}`);
        this.ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.tipo === 'update') {
                const resultados = (data.resultados || []).map(r => ({ ...r, ...r.controles }));
                this.setState({ controles: data.controles, resultados });
            } else if (data.tipo === 'delta') {
                this.setState(prev => ({
                    controles: data.controles || prev.controles,
                    resultados: applyDelta(prev.resultados, data.resultados || [], data.eliminados || []),
                }));
            }
        };
        this.ws.onclose = () => {
            this.wsReconnectTimer = setTimeout(() => this.connectWS(competicionId), 3000);
        };
    }

    componentWillUnmount() {
        if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
        if (this.ws) this.ws.close();
    }

    render() {
        const { competicion, resultados, controles, sectores } = this.state;

        if (!competicion) {
            return (
                <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                    <MsgNetLoading />
                </div>
            );
        }

        return (
            <div>
                {resultados.length > 0 && controles.length > 0 ? (
                    <ResultadosScrapeable
                        resultados={resultados}
                        competicion={competicion}
                        controles={controles}
                        sectores={sectores}
                    />
                ) : (
                    <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                        <MsgNetLoading />
                    </div>
                )}
            </div>
        );
    }
}

function ScrapeableScreen() {
    const params = useParams();
    return <ScrapeableScreenClass params={params} />;
}

export default ScrapeableScreen;
